import bannerImage from "../../images/iDirtHomepageBanner.jpg";

export default function HomePageBanner() {
  return (
	<div className="">
	    <div className="row">
	      <div className="col-md-12 col-sx-12 col-sm-12">
	        <img
	          className="img-fluid"
	          src={bannerImage}
	          style={{
	            paddingLeft: "0px",
	            paddingRight: "0px",
	            width: "100%",
	            height: "450px",
	          }}
	        ></img>
	      </div>
	    </div>
    </div>
  );
}
